
const Request = require('app/graphql/Request');

class MultiMutation extends Request {

	defaultOptions(){
		var self = this;
		var options = {
            'mutationName': 'MultiMutation',
            'mutations': [],//list of app/graphql/Query
		};
		return Object.assign(super.defaultOptions(),options);
	}

    initialize() {

    	return this;
    }


    buildData(){
        let data = this.settings.data;
        data.append('query',this.buildQuery());
        let variables = this.buildVariables();
        if(variables){
            data.append('variables',this.buildVariables());
        }
        return data;
    }

    buildQuery(){
        let mutationName = this.settings.mutationName;

        let variableDefinitions = [];
        let variableParameters = [];

        let variables = this.getVariables();
        let variableNames = Object.keys(variables);

        for(var i in variableNames){
            let name = variableNames[i];
            let variable = variables[name];
            let type = variable.type;
            let nameAsVariable = '$'+name;

            variableDefinitions.push(nameAsVariable+':'+type);
        }
        let variableDefinitionString = '('+variableDefinitions.join(', ')+')';
        if(variableNames.length <= 0){
            variableDefinitionString = '';
        }

        let query = '';
        for(var i in this.settings.mutations){
            let mutationObject = this.settings.mutations[i];
            let currentMutation = mutationObject.buildQuery(true);
            query += `
                ${currentMutation}
            `;
        }

        let mutation = `
        mutation ${mutationName}${variableDefinitionString}{
            ${query}
        }
        `;
        return mutation;
    }

    getVariables(){
        let variables = {};

        for(var i in this.settings.mutations){
            let mutationObject = this.settings.mutations[i];
            let mutationType = mutationObject.getType();
            let childVariables = mutationObject.getVariables();
            let childVariableNames = Object.keys(childVariables);
            for(var j in childVariableNames){
                let key = childVariableNames[j];
                let value = childVariables[key];
                let variableName = key + '_' + mutationType;
                variables[variableName] = value;
            }
        }
        return variables;
    }

    buildVariables(){

        let variableList = {};
        let variables = this.getVariables();
        let variableNames = Object.keys(variables);
        if(variableNames.length <= 0){
            return null;
        }
        for(var i in variableNames){
            let name = variableNames[i];
            let variable = variables[name];
            let type = variable.type;
            let value = variable.value;
            if(type == 'Int' || type == 'Int!'){
                value = parseInt(value);
            }

            variableList[name] = value;
        }

        return JSON.stringify(variableList);
    }

    success(xhr){
        if( this.settings.success && xhr.data){
            return this.settings.success(xhr.data);
        }
    }
    
    error(message, xhr){
        return super.error(message,xhr);
    }



}

module.exports = MultiMutation;
